import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "../NavBar";
import styles from "./AppLayout.module.scss";
import { Overlay } from "../Overlay";
import { ScrollToTopButton } from "../common/ScrollToTopButton";
import { ModeContext } from "../../context/ModeContext";
import { UserContext } from "../../context/UserContext";
import { OverlayContext } from "../../context/OverlayContext";
import { Roles } from "../../apollo/types/Roles";
import { ProtectedRoute } from "../common/ProtectedRoute/ProtectedRoute";
import { Me } from '../../apollo/types/globalTypes';
import { useQuery } from '@apollo/client';
import { ME } from '../../apollo/queries';
import { APPLICATION_TYPE } from '../../enums/application';
import { NavBartStartupLib } from '../NavBarStartupLib';

const getAdminModeValue = () => {
  const mode = localStorage.getItem("adminMode");

  if (mode) {
    return JSON.parse(mode);
  } else {
    localStorage.setItem("adminMode", JSON.stringify(true));
    return true;
  }
};

export const AppLayout = () => {
  const [adminMode, setAdminMode] = useState(getAdminModeValue);
  const [isOverlay, setOverlay] = useState(false);
  const role = localStorage.getItem("userRole");
  const mentorMode = role === Roles.MENTOR;
  const starterMode = role === Roles.STARTUP;

  const handleChangeAdminMode = () => {
    if (role === Roles.STARTUP) {
      throw new Error("Cannot switch to one of the, user is startup");
    }

    setAdminMode(!adminMode);
  };

  // eslint-disable-next-line
  const [myself, setMe] = useState<Me | null>(null);
  const {data} = useQuery<{ me: Me }>(ME, {
    onCompleted: (data) => {
      setMe(data?.me);
      localStorage.setItem('me', JSON.stringify(data.me))
    },
  });

  useEffect(() => {
    const loggedInUser = localStorage.getItem('me');
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setMe(foundUser);
    }
  }, []);

  return (
    <ProtectedRoute toRedirect="/login">
      <OverlayContext.Provider value={{ isOverlay, setOverlay }}>
        <ModeContext.Provider
          value={{ adminMode, mentorMode, starterMode, handleChangeAdminMode }}
        >
          {data !== undefined && data!.me !== undefined &&
            <UserContext.Provider value={data!.me}>
              {process.env.REACT_APP_APPLICATION_TYPE === APPLICATION_TYPE.STARTUP_LIBRARY &&
                  <NavBartStartupLib/>
              }
              {process.env.REACT_APP_APPLICATION_TYPE === APPLICATION_TYPE.DASHBOARD &&
                  <Navbar/>
              }
            <section className={styles.content}>
              <Outlet />
              <ScrollToTopButton />
            </section>
            <Overlay />
            </UserContext.Provider>
          }
        </ModeContext.Provider>
      </OverlayContext.Provider>
    </ProtectedRoute>
  );
};
